import { useMemo } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import {
  DEFAULT_MAP_CENTER,
  GOOGLE_MAPS_API_KEY,
  parseCoord,
} from '@/lib/google-maps';
import { useGoogleMapsLoader } from './useGoogleMapsLoader';

const mapContainerStyle = {
  height: '400px',
  width: '100%',
  borderRadius: '20px',
};

export function Map({ location, handleClick, readOnly = false }) {
  const { isLoaded, loadError } = useGoogleMapsLoader();

  const center = useMemo(
    () => ({
      lat: parseCoord(location?.latitude, DEFAULT_MAP_CENTER.lat),
      lng: parseCoord(location?.longitude, DEFAULT_MAP_CENTER.lng),
    }),
    [location?.latitude, location?.longitude],
  );

  const hasCoordinates =
    Number.isFinite(Number(location?.latitude)) &&
    Number.isFinite(Number(location?.longitude));

  const onMapClick = (e) => {
    if (readOnly || !handleClick || !e.latLng) {
      return;
    }
    handleClick({
      ...(location ?? {}),
      latitude: e.latLng.lat(),
      longitude: e.latLng.lng(),
    });
  };

  if (loadError) {
    return (
      <div style={{ ...mapContainerStyle, padding: '1rem' }}>
        Map could not be loaded. Check your Google Maps API key and network
        connection.
      </div>
    );
  }

  if (!isLoaded) {
    return <div style={mapContainerStyle} />;
  }

  if (!GOOGLE_MAPS_API_KEY?.trim()) {
    return (
      <div style={{ ...mapContainerStyle, padding: '1rem' }}>
        Set <code>VITE_GOOGLE_MAPS_API_KEY</code> in your environment to enable
        the map.
      </div>
    );
  }

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      zoom={hasCoordinates ? 17 : 12}
      center={center}
      onClick={onMapClick}
      options={{ clickableIcons: !readOnly }}
    >
      {hasCoordinates && <Marker position={center} />}
    </GoogleMap>
  );
}
